import fetch from '@/plugin/axios'

// 查询提现日志列表
export function getWithdrawLog (query) {
  return fetch({
    url: '/common/withdraw-log/page',
    method: 'Post',
    data: query
  })
}

// 审核提现
export function getWithdrawAudit (id, status, remark, openid) {
  return fetch({
    url: `/common/withdraw-log/audit/${id}?status=${status}&remark=${remark}&openid=${openid}`,
    method: 'Post'
  })
}
